import React, { type PropsWithChildren } from 'react';

import invariant from 'tiny-invariant';

import { useOptions } from '../../controllers/options-provider';
import { useNetworkSideNavUserData } from '../../controllers/user-state/persistence/use-network-side-nav-user-data';

import { StoreProviders } from './StoreProviders';

export function NetworkStore({ children }: PropsWithChildren) {
	const { networkStorageParams } = useOptions();

	invariant(
		networkStorageParams?.entityAri &&
			networkStorageParams?.ownerAri &&
			networkStorageParams?.queryRef,
		'Please provide networkStorageParams when using customization',
	);

	// This is user data for the menu and the sidebar
	const userStoreProps = useNetworkSideNavUserData(networkStorageParams);

	return <StoreProviders {...userStoreProps}>{children}</StoreProviders>;
}
